import { Component } from '@ecs/Component';

export type HangarEffectKind = 'build' | 'repair' | 'deploy' | 'recall' | 'launch' | 'deny' | 'credits';

/** Asks HangarEffectSystem for the particles and sound of a mothership action. */
export class HangarEffectRequest implements Component {
  readonly type = 'HangarEffectRequest';

  constructor(
    public kind: HangarEffectKind,
    public x: number,
    public y: number,
    public color: string = '#5cc8ff',
    public size: number = 16
  ) {}
}
